<mat-form-field class="search-field style-override">
  <input
    type="text"
    placeholder="Find deliverable by ID"
    matInput
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    #searchInput
  />
  <mat-icon matPrefix class="search-icon">search</mat-icon>
  @if (isSearching()) {
    <app-loader matSuffix [size]="18" />
  }
  <mat-autocomplete
    [autoActiveFirstOption]="options().length === 1"
    (optionSelected)="onSelected($event)"
    #auto="matAutocomplete"
  >
    @if (searchInput.value.length) {
      @if (isSearching()) {
        <mat-option disabled class="italic">Searching...</mat-option>
      } @else if (options().length) {
        @for (option of options(); track option.key) {
          <mat-option [value]="option.key" (keydown.enter)="$event.stopPropagation()">{{
            option.value
          }}</mat-option>
        }
      } @else {
        <mat-option disabled class="italic">No results found</mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
